import React from 'react';
import "./LoadingScreenInline.css";

function LoadingScreenInline(props) {
  return (
    <>
      <div id="loadingInline" >
        <div style={{ width: "100%", display: "flex", opacity: "0.75", justifyContent: "center" }}>
          <div className='lodingInlineStyle' style={{ width: "40%" }}>
          </div>
          <div className='logoLoadingScreenInlineStyle' style={{display: "flex", justifyContent: "center", flexFlow: "column", width: "20%", maxHeight: "300px" }}>
            <img src="/img/loading/cupLogo.gif" width="72" height="72" alt="Loading..." />
            <span>Loading</span>
          </div>
          <div  className='lodingInlineStyle' style={{ width: "40%" }}>
          </div>
       </div>
      </div>
    </>
  )
}
export default LoadingScreenInline;